import requestDefault from '@/shared/utils/request';
import { getActivityUndertakeType } from '@/shared/activity-undertake';
import platform from '@/shared/utils/platform';
import type {
  CreditTaskProduct,
  UserInfoProcessConfig, VerifyTypeEnum,
} from './types';

/**
 * 用户资料流程配置
 * yapi地址: https://yapi.hellobike.cn/project/3415/interface/api/325129
 * 接口服务: 杨钊
 */
export const getUserInfoProcessConfig = (scene: VerifyTypeEnum):
  Promise<UserInfoProcessConfig> => requestDefault.postGate(
  'f.userInfo.processConfig',
  {
    scene,
    /** 若用户属于定向营销活体，则传入空的version不进入新实验分流组 */
    version: getActivityUndertakeType() ? undefined : '1.0.0',
  },
);

/**
 * 捞起挂起流程继续授信申请
 * yapi地址: https://yapi.hellobike.cn/project/3415/interface/api/325142
 * 接口服务: 杨钊
 */
export const continueCreditApplyTask = ():
  Promise<void> => requestDefault.postGate(
  'f.credit.apply.continue.task',
  {},
  { showErrMsg: undefined },
);

/**
 * 任务id查询对应授信的渠道id
 * yapi地址:https://yapi.hellobike.cn/project/3415/interface/api/326687
 * 接口服务: 杨钊
 */
export const queryTaskProduct = (creditTaskId: string):
Promise<{ creditProducts: CreditTaskProduct[] }> => requestDefault.postGate(
  'f.query.task.product',
  {
    creditTaskId,
  },
);

/**
 * 用户二要素信息保存
 * yapi地址: https://yapi.hellobike.cn/project/4693/interface/api/412503
 * 接口服务: 李绪
 */
export const twoFactorIdentitySave = (
  factorInfo: { userName: string, idCardNo: string },
  { showErrMsg }: { showErrMsg: (msg: string, error: unknown) => void },
): Promise<void> => requestDefault.postGate(
  'f.fate.user.two.factor.identity.save',
  {
    ...factorInfo,
    systemCode: platform.systemCode,
  },
  {
    showErrMsg,
  },
);
